import React from "react"

interface BadgeProps {
  title: string
}

export function Badge({ title }: BadgeProps) {
  return (
    <div className="leading-3.5 whitespace-nowrap rounded-sm bg-gray-700 px-2 py-1 text-xs font-semibold uppercase text-white antialiased">
      {title}
    </div>
  )
}
